import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

const translations = [
  { lang: "en", text: "The Floor", subtitle: "Sovereign Strategic Intelligence Suite" },
  { lang: "es", text: "The Floor", subtitle: "Suite de Inteligencia Estratégica Soberana" },
  { lang: "fr", text: "The Floor", subtitle: "Suite d'Intelligence Stratégique Souveraine" },
  { lang: "de", text: "The Floor", subtitle: "Souveräne Strategische Intelligenz-Suite" },
  { lang: "pt", text: "The Floor", subtitle: "Suite de Inteligência Estratégica Soberana" },
  { lang: "zh", text: "The Floor", subtitle: "主权战略情报套件" },
  { lang: "ar", text: "The Floor", subtitle: "جناح الاستخبارات الاستراتيجية السيادية" },
  { lang: "he", text: "The Floor", subtitle: "חבילת מודיעין אסטרטגי ריבוני" },
  { lang: "ru", text: "The Floor", subtitle: "Суверенный Стратегический Разведывательный Комплекс" },
];

interface Props {
  className?: string;
  subtitleClassName?: string;
}

const AnimatedTranslationText = ({ className, subtitleClassName }: Props) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % translations.length);
    }, 60_000);
    return () => clearInterval(interval);
  }, []);

  const current = translations[index];

  return (
    <div className="relative">
      <AnimatePresence mode="wait">
        <motion.div
          key={current.lang}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className={className}>
            <span className="text-gradient-gold">{current.text}</span>
          </h1>
          <p className={subtitleClassName}>{current.subtitle}</p>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default AnimatedTranslationText;
